import { StorageIds } from '../constants/storage'
import { isDevMode } from '../envs/envs'
import { getUrlParam } from '../utils/utils'

export const setActiveRegionId = (activeRegionId: string) => {
  localStorage.setItem(StorageIds.activeRegionId, activeRegionId)
  activeRegionId === 'default' && console.warn('Active region id is not defined, set to default')
}

export const getActiveRegionId = () => {
  // return 'poland' // restore to original before merging
  return getUrlParam('regionId') || localStorage.getItem(StorageIds.activeRegionId) || ''
}

/**
 * @deprecated SWD-604
 */
export const setPendingRegionId = (pendingRegionId: string) => {
  localStorage.setItem(StorageIds.pendingRegionId, pendingRegionId)
}

/**
 * @deprecated SWD-604
 */
export const getPendingRegionId = () => {
  return localStorage.getItem(StorageIds.pendingRegionId) || ''
}

export const setUserSelectedRegionId = (userSelectedRegionId: string) => {
  localStorage.setItem(StorageIds.userSelectedRegionId, userSelectedRegionId)
}

export const getUserSelectedRegionId = (availableRegionIds?: Nullable<string[]>) => {
  const userSelectedRegionId = localStorage.getItem(StorageIds.userSelectedRegionId) || ''

  if (isDevMode && userSelectedRegionId !== 'auto') {
    return userSelectedRegionId
  }
  if (availableRegionIds?.includes(userSelectedRegionId)) {
    return userSelectedRegionId
  } else {
    isDevMode &&
      console.log(`${userSelectedRegionId} region id not allowed, list of available region ids: ${availableRegionIds}`)
  }
}
